// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","container":"SuggestionCard_container__3zwe3","thumbnail":"SuggestionCard_thumbnail__2pDvB"};